import AlertComponent from '../../control-components/ui-components/AlertComponent'

const ErrorList = ({ errors = [] }) => {
  if (!errors.length) return null

  return <div class='content-errors'>
    {
      errors.map(({ errorMessage }) =>
        <AlertComponent messageType={'error'} message={errorMessage} />
      )
    }
  </div>
}

export default ErrorList
